import React from "react";
import path from '../../../img/partners/cexio.png'

const Cexio: React.FunctionComponent = () => (
  <img src={path}/>
)

export default Cexio
